import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from '@klv/hooks/useTranslation';
import * as s from './styles';

import type { ICountdownTimer, ITimeRemaining } from './types';
import { calculateTimeRemaining } from './utils/functions';

const CountdownTimer = ({
  targetDate,
  setDisplayed,
  ...props
}: ICountdownTimer) => {
  const { t } = useTranslation();

  const [timeRemaining, setTimeRemaining] = useState<ITimeRemaining>(calculateTimeRemaining(targetDate));

  useEffect(() => {
    const timer = setInterval(() => {
      const timeLeft = calculateTimeRemaining(targetDate);
      // if we're out of time, setDisplayed to false and do not update the local state
      if (
        timeLeft.days === '00' && 
        timeLeft.hours === '00' && 
        timeLeft.minutes === '00' && 
        timeLeft.seconds === '00'
      ) {
        setDisplayed(false);
      }
      // if there is time left, set time remaining.
      setTimeRemaining(timeLeft);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  // create an array of the intervals so we can cut out some code (days, hours, minutes, seconds)
  let timeIntervals: string[] = [];
  if (timeRemaining) {
    timeIntervals = Object.keys(timeRemaining);
  }

  return (
    <s.StyledCountdownTimer {...props}>

      {timeIntervals.map((measurement, index) => (
        <Fragment key={measurement}>
          <s.CountdownNumberContainer>
            <s.CountdownNumber variant="h2" forwardedAs="div">
              {timeRemaining[measurement as keyof ITimeRemaining]}
            </s.CountdownNumber>
            <s.CountdownNumberLabel variant="h6" forwardedAs="div">
              {t(`molecules_countdownTimer_${measurement}`)}
            </s.CountdownNumberLabel>
          </s.CountdownNumberContainer>
          
          {/* We put a slash between the intervals */}
          {index < timeIntervals.length - 1 ? (
            <s.CountdownNumberSlash variant="h2" forwardedAs="div" children="/" />
          ) : ''}
        </Fragment>
      ))}

    </s.StyledCountdownTimer>
  );
};

export default CountdownTimer;
